import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import {
  SEGMENTATION_IDS,
  type SegmentationId,
} from 'lumen/models/total-revenue/segmentation-breakdown/item';
import ApplicationSerializer from 'lumen/serializers/application';

interface SegmentationBreakdownItemPayload {
  segmentation_id: SegmentationId;
}

interface SegmentationBreakdownsPayload {
  segmentation_breakdowns: {
    segment: SegmentationBreakdownItemPayload[];
  };
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class SegmentationBreakdownsSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    summary: { embedded: 'always' },
    segment: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'segmentation_breakdowns') {
      return 'total-revenue/segmentation-breakdowns';
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  /**
   * Add segmentation_id to each segment
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: SegmentationBreakdownsPayload,
    id: string | number,
    requestType: string,
  ) {
    Object.values(SEGMENTATION_IDS).forEach((segmentationId) => {
      payload.segmentation_breakdowns[segmentationId].forEach((segment) => {
        segment.segmentation_id = segmentationId;
      });
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }
}
